import palette from './palette';

const global = {
  success: {
    background: palette.green,
    text: palette.white,
  },
  information: {
    background: palette.blue,
    text: palette.white,
  },
  error: {
    background: palette.red,
    text: palette.white,
  },
  warning: {
    background: palette.yellow,
    text: palette.blueNavy,
  },
  offer: {
    background: palette.purple,
    text: palette.white,
  },
  winner: {
    background: palette.yellowButter,
    text: palette.white,
  },
};

export type ThemeBase = typeof global & {
  theme: 'light' | 'dark';
  background: palette;
  surface: palette;
  active: palette;
  content: palette;
  subContent: palette;
  divisions: palette;
};

export const lightTheme: ThemeBase = {
  theme: 'light',
  active: palette.blue,
  background: palette.blueWhite,
  surface: palette.white,
  content: palette.blueDenim,
  subContent: palette.blueSlate,
  divisions: palette.blueGrey,
  ...global,
};

export const darkTheme: ThemeBase = {
  theme: 'dark',
  background: palette.blueInk,
  surface: palette.blueNavy,
  active: palette.blue,
  content: palette.white,
  subContent: palette.blueGrey,
  divisions: palette.blueDenim,
  ...global,
};
